export const name = "KLL_QUANTILES.EXTRACT_FLOAT64";
export const summary = `Gets a selected number of quantiles from a \`FLOAT64\`-initialized KLL sketch.`;
export const reference = `
## KLL_QUANTILES.EXTRACT_FLOAT64

Gets a selected number of quantiles from a \`FLOAT64\`-initialized KLL sketch.

\`\`\`
KLL_QUANTILES.EXTRACT_FLOAT64(sketch, num_quantiles)
\`\`\`

### Description

Like \`KLL_QUANTILES.EXTRACT_INT64\`, but accepts KLL sketches initialized on data of type\`FLOAT64\`.


### Return Type

\`ARRAY<FLOAT64>\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
